var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "alert-wrap" },
    [
      _c(
        "transition-group",
        { attrs: { name: _vm.transition, tag: "div" } },
        _vm._l(_vm.notifications, function(item, index) {
          return _c(
            "div",
            {
              key: "notification-" + index,
              class: item.typeObject,
              attrs: { role: "alert" }
            },
            [
              _vm.displayIcons
                ? _c("span", { class: item.iconObject })
                : _vm._e(),
              _c("span", { domProps: { innerHTML: _vm._s(item.message) } })
            ]
          )
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e43b8b6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e43b8b6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/Flash.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-7e43b8b6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/Flash.vue
// module chunks = 15 16 17 18 20